import { FC } from 'react';
import { Typography } from '@dagensmat/carrot/Components';
import styled from 'styled-components';

const StyledContainer = styled.div`
  white-space: nowrap;
`;

type Props = {
  maxLength: number;
  valueLength: number;
};

export const FormFieldCharCount: FC<Props> = ({ maxLength, valueLength }) => {
  return (
    <StyledContainer>
      <Typography variant="paragraphSmall" color="secondary">
        {valueLength} / {maxLength}
      </Typography>
    </StyledContainer>
  );
};
